// Union list and per-union passwords.
// In production, move password validation to a backend endpoint.
const UNIONS = [
  { id: 'TL237', label: 'Teamsters Local 237', password: 'TL237!' },
];

export default UNIONS;
